export class PathModalService {
  private isReminderModalOpen: boolean;
  private isAutoCompleteModalOpen: boolean;

  constructor() {
    this.isReminderModalOpen = false;
    this.isAutoCompleteModalOpen = false;
  }

  get reminderModalOpen(): boolean {
    return this.isReminderModalOpen;
  }

  get autoCompleteModalOpen(): boolean {
    return this.isAutoCompleteModalOpen;
  }

  toggleReminderModal(state: boolean) {
    this.isReminderModalOpen = state;
  }

  toggleAutoCompleteModal(state: boolean) {
    this.isAutoCompleteModalOpen = state;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/modals/path_modal_service.ts